import { TumblerProps } from "@yandex-int/hr-components/Tumbler";
import { Tumbler as BaseTumbler } from "@yandex-int/hr-components/Tumbler";
import React from "react";
import styles from './tumbler.module.scss';

interface ITumblerProps extends TumblerProps {
}

export const Tumbler: React.FC<ITumblerProps> = ({
                                                     ...props
                                                 }) => (
    <div className={styles.container}>
        <BaseTumbler
            {...props}
        />
    </div>
);
